import { PreferencesService } from 'src/app/services/preferences.service';
import { PREFERENCES_LIST } from 'src/app/shared/utils';
import { UntypedFormControl, UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { TextFieldModule } from '@angular/cdk/text-field';
import { MatInputModule } from '@angular/material/input';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-accessibility-settings',
  templateUrl: './accessibility-settings.component.html',
  styleUrls: ['./accessibility-settings.component.scss'],
  standalone: true,
  imports: [MatIconModule, MatDialogModule, MatFormFieldModule, FormsModule, ReactiveFormsModule, MatSlideToggleModule, MatInputModule, TextFieldModule, MatButtonModule, TranslateModule]
})
export class AccessibilitySettingsComponent implements OnInit {

  public preferences = PREFERENCES_LIST;
  public preferencesForm = new UntypedFormGroup({
    delivery_without_bags: new UntypedFormControl(false),
    receive_messages_calls: new UntypedFormControl(false),
    change_products: new UntypedFormControl(false),
    disability_physical_mental: new UntypedFormControl(false),
    extra_info: new UntypedFormControl(''),
  });
  public preferencesResponse: any;

  constructor(
    private preferencesService: PreferencesService,
    private dialogRef: MatDialogRef<AccessibilitySettingsComponent>,
  ) { }

  ngOnInit(): void {
    this.getPreferences();
  }

  public async getPreferences(): Promise<any> {
    try {
      const response = await this.preferencesService.getPreferences();
      this.preferencesResponse = response.data;
      this.preferencesForm.patchValue({
        delivery_without_bags: response?.data[0]?.delivery_without_bags ?? false,
        receive_messages_calls: response?.data[0]?.receive_messages_calls ?? false,
        change_products: response?.data[0]?.change_products ?? false,
        disability_physical_mental: response?.data[0]?.disability_physical_mental ?? false,
        extra_info: response?.data[0]?.extra_info,
      });
    } catch (error) { }
  }

  public async updateAccessibility(): Promise<any> {
    try {
      if (this.preferencesResponse[0]?.delivery_without_bags !== undefined) {
        await this.preferencesService.updatePreferences(this.preferencesForm.value);
        this.dialogRef.close(true);
      } else {
        await this.preferencesService.createPreferences(this.preferencesForm.value);
        this.dialogRef.close(true);
      }
    } catch (error) { }
  }
}
